"use client"; 

import React from 'react';
import { useLocation } from 'react-router-dom'; 
import Footerlast from './Footerlast';
import Url from '../../src/Url';
import Image2 from '../../src/Images/bombay.png';


const Footer = () => {
  const location = useLocation(); 
  const pathname = location.pathname; 

  const showStarRating = [
    "/cleaning-management-software/",
    "/handyman-management-software/",
    "/facilities-management-software/",
    "/trucking/",
    "/telemedicine/",
    "/hospital/",
  ].includes(pathname) || pathname.startsWith("/solutions/");
  return (
    <>
    <footer className="footer">
      
        <div className="footer-logos">
          <img src={`${Url.imageUrl}footer/goodfirmsn.png`} alt="GoodFirms Logo" className='goodfirms' width={120} height={200} loading="lazy" />
          <img src={`${Url.imageUrl}footer/google.png`} alt="Google Logo" width={100} height={30} className='googlelogo' loading="lazy"/>
          <img src={`${Url.imageUrl}opt/mainlogodark.webp`} alt="AI Logo" width={100} height={50}   className='ailogo' loading="lazy" />
          <img src={`${Url.imageUrl}footer/aws.png`} alt="AWS Logo" width={100} height={30}   className='awslogo' loading="lazy"/>
          <img src={`${Url.imageUrl}footer/clutch.png`} alt="Clutch Logo" width={100} height={90}  className='clutchlogo' loading="lazy" />
          {/* <img className="logChamber" src={Image2} style={{width:"180px"}} ></img> */}
          <img src={Image2} alt="bombay_chembers"  width={100} height={190}  loading="lazy"/>
        </div>

        <div className="media">
        <ul className="social">
              <li className="linkedin">
                  <a
                    href="https://www.linkedin.com/company/trailique-infotech/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Visit our Linkdn profile"
                  >
                    <img
                      alt="LinkedIn"
                      src={`${Url.imageUrl}footer/linkedin.png`}
                      width={20}
                      height={20}
                      style={{
                        display: "inline-block",
                        verticalAlign: "middle",
                      }}
                    />
                  </a>
                </li>
                        
                        
                <li className="youtube">
                  <a
                    href="https://www.youtube.com/@trAIlique_Infotech"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Visit our youtube profile"
                  >
                    <img
                      alt="YouTube"
                      src={`${Url.imageUrl}footer/youtube.png`}
                      width={20}
                      height={20}
                      style={{
                        display: "inline-block",
                        verticalAlign: "middle",
                        marginTop:"10px",
                      }}
                    />
                  </a>
                </li>
                <li className="facebook">
                  <a
                    href="https://www.facebook.com/trAIlique"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Visit our Facebook profile"
                  >
                     <img
                      alt="YouTube"
                      src={`${Url.imageUrl}footer/facebook.png`}
                      width={20}
                      height={20}
                      style={{
                        display: "inline-block",
                        verticalAlign: "middle",
                      }}
                    />
                  </a>
                </li>
                <li className="twitter">
                  <a
                    href="https://x.com/trAIlique_info"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Visit our Twitter profile"
                  >
                    <img
                      alt="Twitter"
                      src={`${Url.imageUrl}footer/twitter.png`}
                      width={20}
                      height={20}
                      style={{
                        display: "inline-block",
                        verticalAlign: "middle",
                        color: "white",
                      }}
                    />
                  </a>
                </li>
                <li className="instagram">
                  <a
                    href="https://www.instagram.com/trailique_infotech/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      alt="Twitter"
                      src={`${Url.imageUrl}footer/instagram.png`}
                      width={20}
                      height={20}
                      style={{
                        display: "inline-block",
                        verticalAlign: "middle",
                        color: "white",
                      }}
                    />
                  </a>
                </li>
                
                
                <li className="whatsapp">
                  <a
                    href="https://wa.me/8177844080"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Visit our Whatsapp profile"
                  >
                    <img
                      alt="Twitter"
                      src={`${Url.imageUrl}footer/whatsapp.png`}
                      width={20}
                      height={20}
                      style={{
                        display: "inline-block",
                        verticalAlign: "middle",
                        color: "white",
                      }}
                    />
                  </a>
                </li>

              </ul>
        </div>
        

      <div className="footer-columns">
      <div className="footer-column">
            <h3>Solutions</h3>
            <ul>
            <li><a href="/solutions/facilities-management-software">Facility Management Software</a></li>
              <li><a href="/solutions/handyman-management-software">Handyman Software</a></li>
              <li><a href="/solutions/cleaning-management-software">Cleaning Management Software</a></li>
              <li><a href="/">Truck Booking Software</a></li>
              <li><a href="/">Telemedicine Software</a></li>
              <li><a href="/">Last-Mile Delivery Software</a></li>
              <li><a href="/">Event Transportation Software</a></li>
              <li><a href="/">EV Transportation Solution</a></li>
              <li><a href="/">Employee Transportation Software</a></li>
              <li><a href="/">E-Commerce Solution</a></li>
              <li><a href="/">M-Commerce Solution</a></li>
              <li><a href="/">Aircrew Transit Software</a></li>
              <li><a href="/">Group Transportation Software</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h3>Services</h3>
            <ul>
              <li><a href="/">AI & ML Ecosystem</a></li>
              <li><a href="/services/iot-development-services">IoT Ecosystem</a></li>
              <li><a href="/">Digital Transformation</a></li>
              <li><a href="/">Digital Twin</a></li>
              <li><a href="/">Cyber Resilience</a></li>
              <li><a href="/">Custom Mobile App Development</a></li>
              <li><a href="/">Cybersecurity Management</a></li>
              <li><a href="/">Discovery, Prototyping & MVP</a></li>
              <li><a href="/">Website Audit</a></li>
              <li><a href="/">SEO Services</a></li>
              <li><a href="/">UI/UX Designing</a></li>
              <li><a href="/">Website Development</a></li>

            </ul>
          </div>

          <div className="footer-column">
           <div className='noheading'>
            <ul>
              <li><a href="/">QA Testing</a></li>
              <li><a href="/">App Enhancement & Integration</a></li>
              <li><a href="/">Staffing Services</a></li>
              <li><a href="/">DevOps Services</a></li>
              <li><a href="/">IT Maintenance & Support</a></li>
              <li><a href="/">Digital Commerce</a></li>
              <li><a href="/">Product Development</a></li>
              <li><a href="/">Custom Software Development</a></li>
              <li><a href="/">Cloud Services</a></li>
              <li><a href="/">Robotic Process Automation</a></li>
              <li><a href="/">Shopify Growth Consulting</a></li>
            </ul>
            </div>
          </div>

          <div className="footer-column">
            <h3>Industries</h3>
            <ul>
              <li><a href="/">Finance & Banking</a></li>
              <li><a href="/">Healthcare</a></li>
              <li><a href="/">Retail & E-commerce</a></li>
              <li><a href="/">Manufacturing</a></li>
              <li><a href="/">Transportation & Logistics</a></li>
              <li><a href="/">Startups</a></li>
              <li><a href="/">Automotive</a></li>
              <li><a href="/">Agriculture</a></li>
              <li><a href="/">Public Sector & Government</a></li>
              <li><a href="/">Logistics & Supply Chain</a></li>
              <li><a href="/">Construction & Engineering</a></li>
              <li><a href="/">Pharmaceuticals</a></li>

            </ul>
          </div>

          <div className="footer-column">
            <h3>Company</h3>
            <ul>
              <li><a href="/about-us/">About</a></li>
              <li><a href="/">The tr<span style={{color:"#3681f4"}}>AI</span>lique Way</a></li>
              <li><a href="/company/partners">Partners</a></li>
              <li><a href="/">CSR</a></li>
              <li><a href="/blog">Blogs</a></li>
              <li><a href="/career">Careers</a></li>
              <li><a href="/technology-stack">Technology Stack</a></li>

            </ul>
            <h3>Consultation<br/> Request</h3>
            <h4 style={{fontSize:"20px"}}> <a href="mailto:info@trailique.ai">info@trailique.ai</a></h4>
            <p> +1 (408) 493-2090 <br />+91 8177 844 080</p>
          </div>


      </div>

      
      
          {/* Star Rating Section */}
          {showStarRating && (
          <div className="footer-bottom">
            <p><span>
              <img
                src={`${Url.imageUrl}footer/five.png`}
                alt="We also have been rated 5.0 / 5.0 from 143+ clients"
                title="We also have been rated 5.0 / 5.0 from 143+ clients"
                height="25"
                width="67"
              />
              </span> &nbsp;
              Rated 5.0 / 5.0 by 143+ Clients for AI-Driven Innovations for Business Transformation.
            </p>
          </div>
        )}

      
    </footer>
    <Footerlast/>
    </>
  );
};

export default Footer;

